import { EyeClosed, EyeOpen } from './Eye.styles';

const Eye = ({ active }: { active: boolean }) => {
  switch (active) {
    case true:
      return (
        <EyeClosed width={20} height={20} />
      );
    default:
      return (
        <EyeOpen width={20} height={20} />
      );
  }
};

export default Eye;
